// extracted by mini-css-extract-plugin
export default {"wrapper":"Feature_wrapper__7p4+U","text":"Feature_text__rYg1a","grid":"Feature_grid__viq0j","mainHeading":"Feature_mainHeading__ywDQL","secHeading":"Feature_secHeading__ALhzt"};